var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "answer",
    style: {
      backgroundImage:
        "url(" +
        JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
          .answer.background.pictureUrl +
        ")"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }